export default () => ({
  templates: [],
  lsTemplates: [],
  categoriesTree: [],
  selectedCategory: null,
  keyword: null,
})
